import React from 'react';
import { cn } from '../../lib/utils';

const TooltipContext = React.createContext<{
  open: boolean;
  setOpen: (open: boolean) => void;
}>({ open: false, setOpen: () => {} });

export function TooltipProvider({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
}

export function Tooltip({ children }: { children: React.ReactNode }) {
  const [open, setOpen] = React.useState(false);
  return (
    <TooltipContext.Provider value={{ open, setOpen }}>
      <div className="relative inline-block">{children}</div>
    </TooltipContext.Provider>
  );
}

export function TooltipTrigger({ children, className }: { children: React.ReactNode; className?: string }) {
  const { setOpen } = React.useContext(TooltipContext);
  return (
    <div
      className={className}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      {children}
    </div>
  );
}

export function TooltipContent({ children, className }: { children: React.ReactNode; className?: string }) {
  const { open } = React.useContext(TooltipContext);
  if (!open) return null;
  return (
    <div
      className={cn(
        'absolute z-50 -top-8 left-1/2 -translate-x-1/2 overflow-hidden rounded-md border border-border bg-surface-raised px-3 py-1.5 text-sm text-text-primary shadow-md',
        className,
      )}
    >
      {children}
    </div>
  );
}
